/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {setFeatureFlags} from '../api'

export const useMutationSetFeatureFlags = createReactQueryMutationHook('setFeatureFlags', setFeatureFlags)
